export const parseColorToRGB = (val) => {
  if (!val) return null;
  const s = String(val).trim();
  const hex = s.match(/^#([\da-f]{3}|[\da-f]{6})$/i);
  if (hex) {
    let h = hex[1];
    if (h.length === 3)
      h = h
        .split("")
        .map((c) => c + c)
        .join("");
    const r = parseInt(h.slice(0, 2), 16);
    const g = parseInt(h.slice(2, 4), 16);
    const b = parseInt(h.slice(4, 6), 16);
    return `${r}, ${g}, ${b}`;
  }
  const rgb = s.match(/^rgba?\s*\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)/i);
  if (rgb) return `${rgb[1]}, ${rgb[2]}, ${rgb[3]}`;
  const temp = document.createElement("div");
  temp.style.color = s;
  document.body.appendChild(temp);
  const cs = getComputedStyle(temp).color;
  document.body.removeChild(temp);
  const m = cs.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
  return m ? `${m[1]}, ${m[2]}, ${m[3]}` : null;
};
